import React, { useState, useEffect } from 'react';
import { useAdminAuth } from '../context/AdminAuthContext';
import {
  getSingleFilePriceAdmin, updateSingleFilePrice,
  getDailyLimitAdmin, updateDailyLimit
} from './../api/adminApi';

export const AdminSettings = () => {
  const { token } = useAdminAuth();
  const [price, setPrice] = useState('');
  const [dailyLimit, setDailyLimit] = useState('');
  const [loading, setLoading] = useState(true);
  const [savingPrice, setSavingPrice] = useState(false);
  const [savingLimit, setSavingLimit] = useState(false);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  useEffect(() => {
    async function loadSettings() {
      setLoading(true);
      const [priceResult, limitResult] = await Promise.all([
        getSingleFilePriceAdmin(token),
        getDailyLimitAdmin(token)
      ]);
      setLoading(false);

      if (priceResult.success) setPrice(String(priceResult.data.price));
      if (limitResult.success) setDailyLimit(String(limitResult.data.limit));

      if (!priceResult.success) setToast({ show: true, type: 'error', message: priceResult.message });
      else if (!limitResult.success) setToast({ show: true, type: 'error', message: limitResult.message });
    }
    loadSettings();
    // eslint-disable-next-line
  }, []);

  const handleSavePrice = async () => {
    if (!price || Number(price) <= 0) {
      setToast({ show: true, type: 'error', message: 'لطفا یک قیمت معتبر وارد کنید.' });
      return;
    }

    setSavingPrice(true);
    const result = await updateSingleFilePrice(token, price);
    setSavingPrice(false);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  const handleSaveLimit = async () => {
    if (!dailyLimit || Number(dailyLimit) <= 0) {
      setToast({ show: true, type: 'error', message: 'لطفا یک عدد معتبر وارد کنید.' });
      return;
    }

    setSavingLimit(true);
    const result = await updateDailyLimit(token, dailyLimit);
    setSavingLimit(false);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  const inputStyle = {
    border: '1px solid white',
    backgroundColor: 'transparent',
    color: 'white',
    borderRadius: 8,
    height: 40,
    marginBottom: 16
  };

  return (
    <div dir="rtl" style={{ padding: 24 }}>
      <h2 className="w3-text-white" style={{ marginBottom: 20 }}>تنظیمات سایت</h2>

      <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
        {/* قیمت تک فایل */}
        <div className="w3-card-4 w3-round-large" style={{ backgroundColor: '#263238', padding: 24, width: 380 }}>
          <h4 className="w3-text-white" style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}>
            <i className="material-icons w3-margin-left" style={{ color: '#4FC3F7' }}>attach_money</i>
            قیمت دانلود تک فایل
          </h4>

          {loading ? (
            <p className="w3-text-grey">در حال بارگذاری...</p>
          ) : (
            <>
              <label className="w3-text-white">قیمت (تومان)</label>
              <input
                type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className="w3-input"
                style={inputStyle}
              />
              <button
                onClick={handleSavePrice}
                disabled={savingPrice}
                className="w3-button w3-block"
                style={{ color: '#15ff00', border: '2px solid #2980b9', backgroundColor: 'transparent', borderRadius: 10 }}
              >
                {savingPrice ? 'در حال ذخیره...' : 'ذخیره تغییرات'}
              </button>
            </>
          )}
        </div>

        {/* محدودیت دانلود روزانه */}
        <div className="w3-card-4 w3-round-large" style={{ backgroundColor: '#263238', padding: 24, width: 380 }}>
          <h4 className="w3-text-white" style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}>
            <i className="material-icons w3-margin-left" style={{ color: '#ff9800' }}>speed</i>
            محدودیت دانلود روزانه
          </h4>

          {loading ? (
            <p className="w3-text-grey">در حال بارگذاری...</p>
          ) : (
            <>
              <label className="w3-text-white">حداکثر تعداد دانلود در روز (برای هر کاربر)</label>
              <input
                type="number"
                value={dailyLimit}
                onChange={(e) => setDailyLimit(e.target.value)}
                className="w3-input"
                style={inputStyle}
              />
              <button
                onClick={handleSaveLimit}
                disabled={savingLimit}
                className="w3-button w3-block"
                style={{ color: '#15ff00', border: '2px solid #2980b9', backgroundColor: 'transparent', borderRadius: 10 }}
              >
                {savingLimit ? 'در حال ذخیره...' : 'ذخیره تغییرات'}
              </button>
            </>
          )}
        </div>
      </div>

      {toast.show && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 320, maxWidth: '90%', overflow: 'hidden' }}>
            <div
              className="w3-container w3-padding"
              style={{ backgroundColor: toast.type === 'success' ? '#15ff0022' : '#ff000022', borderBottom: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}` }}
            >
              <span onClick={() => setToast({ ...toast, show: false })} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>{toast.type === 'success' ? '✅ موفقیت' : '❌ خطا'}</h4>
            </div>
            <div className="w3-container w3-padding"><p className="w3-text-white">{toast.message}</p></div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16 }}>
              <button
                onClick={() => setToast({ ...toast, show: false })}
                className="w3-button w3-block"
                style={{ color: toast.type === 'success' ? '#15ff00' : '#ff0000', border: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}`, backgroundColor: 'transparent', borderRadius: 10 }}
              >
                باشه
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};